import React, {useState, useContext} from 'react';
import AppContext from './AppContext';
import {StyleSheet} from 'react-native';
import {Text, View} from '../components/Themed';
import {useGoogleMaps} from 'react-hook-google-maps';

import AddressAutocomplete from '../components/AddressAutocomplete';

const AddressSearch = function (props: any) {
  const appContext = useContext(AppContext);

  const { ref, map, google } = useGoogleMaps(
    // Use your own API key, you can get one from Google (https://console.cloud.google.com/google/maps-apis/overview)
    "AIzaSyAy3K6xbHzSmes_U6CeCQ56qDTv1v-Vxb8",
    // NOTE: even if you change options later
    {
      center: { lat: 0, lng: 0 },
      zoom: 3
    }
  );

  return (
    <View style={[styles.addressView, {zIndex: props.zIndex}]}>
      <Text style={styles.addressType}>{props.addressType}</Text>
      <AddressAutocomplete
        addressType={props.addressType}
        placeholder={`Enter ${props.addressType} address`}
        zIndex={props.zIndex}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  addressView: {
    marginTop: '20px',
    marginBottom: '20px',
  },
  addressType: {
    textTransform: 'capitalize',
    height: '20px',
  },
});

export default AddressSearch;
